export const removeSpecialCharacters = (string: string) =>
  string.replace(/-|\s|#/g, '');
